import { render, staticRenderFns } from "./product-dropdown.vue?vue&type=template&id=1d9005e0&"
import script from "./product-dropdown.vue?vue&type=script&lang=tsx&"
export * from "./product-dropdown.vue?vue&type=script&lang=tsx&"
import style0 from "./product-dropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports